import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useUID } from 'react-uid';
import { PaymentService } from 'config';
import Braintree from 'services/Braintree';
import type { OnToken } from 'services/Braintree';

type Props = {
  show: boolean;
  standalone?: boolean;
  onToken: OnToken;
};

function PayPalProvider({
  show,
  standalone = false,
  onToken,
}: Props): ReactElement {
  const uid = useUID();

  useEffect(() => {
    const elementId = `payment-method-paypal-${uid}`;
    const element = document.getElementById(elementId);

    if (show && element) {
      Braintree.renderPayPal(
        `#${elementId}`,
        (token, address) => onToken(PaymentService.PAYPAL, token, address),
      );
    }
  }, [uid, show, onToken]);
  // @ts-expect-error TODO: fix null safety
  return show && (
    standalone ? (
      <div id={`payment-method-paypal-${uid}`} />
    ) : (
      <div
        className={[
          'c-payment-form__body',
          'c-payment-form__body--paypal',
          'collapse',
          'show',
        ].join(' ')}
      >
        <div className="c-alternative-payment-buttons">
          <div>
            <div id={`payment-method-paypal-${uid}`} />
          </div>
        </div>
      </div>
    )
  );
}

export default PayPalProvider;
